import { Injectable } from '@angular/core';

@Injectable()
export class GoogleMapaService {

    constructor() { }
    calcularRuta(directionsService, directionsDisplay, servicio){
        
        let puntosIntermedios = this.generarArregloDePuntosIntermedios(servicio);

        let directionsRequest = {
            origin: servicio.origen.coordenadas,
            destination: servicio.destino.coordenadas,
            travelMode: 'DRIVING',
            waypoints : puntosIntermedios.length > 0 ? puntosIntermedios : [],
            provideRouteAlternatives : false
        };

        directionsService.route(directionsRequest,(response, status) => {
            if (status === 'OK') 
                directionsDisplay.setDirections(response);
            else 
                window.alert('Directions request failed due to ' + status);
        });
    }

    generarArregloDePuntosIntermedios(servicio):Array<any>{
        // Crea un arreglo de los puntos intermedios del viaje para poder mostrarlos
        let arregloPuntosIntermedios = [];
        for(let idPuntoIntermedio in servicio.puntosIntermedios){
            let objPuntoIntermedio = {
                location : servicio.puntosIntermedios[idPuntoIntermedio].coordenadas,
                stopover : true
            };
            arregloPuntosIntermedios.push(objPuntoIntermedio);
        }
        return arregloPuntosIntermedios;
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/google-map.service.ts